import { getAccessToken } from 'cng-common/helpers/access'
import { downloadBlob } from 'cng-common/helpers/io'
import { NotificationController } from 'core-components/library/popup'
import Logger from 'core/utils/Logger'
import settings from 'src/config/settings'

interface IExportSobSubmittingReportParameters {
  filename: string
  entryId: number | number[]
  headerEntryIds?: number[]
  mappings: Partial<Record<string, unknown>>
}

const mapFormattedMappings = (entryId: number, mappings: Partial<Record<string, unknown>>) => {
  return {
    EntryId: entryId,
    Keys: mappings,
  }
}

export async function exportReport({
  filename,
  entryId,
  mappings,
  headerEntryIds = [],
}: IExportSobSubmittingReportParameters) {
  const isArray = entryId instanceof Array
  if (isArray && !entryId.length) {
    throw new Error('No mapping ids provided')
  }
  const mappingEntryIds = isArray ? entryId : [entryId]
  const formattedMappings = mappingEntryIds.map((it) => mapFormattedMappings(it, mappings))
  const formattedHeaderMappings = headerEntryIds?.map((it) =>
    mapFormattedMappings(it, { FYear: mappings.FYear })
  )
  const stringifiedMappings = JSON.stringify([...formattedMappings, ...formattedHeaderMappings])
  const p360ServiceHost = settings.httpsServices.partner360
  const url = `${p360ServiceHost}/api/v0/exportDocument/download`
  const accessToken = getAccessToken()
  const payload = { filename, mappings: stringifiedMappings, attachment: null }
  const request = {
    headers: {
      Authorization: `${accessToken}`,
    },
    method: 'POST',
    body: JSON.stringify(payload),
  }

  try {
    const response = await fetch(url, request)

    if (response.ok) {
      const blob = await response.blob()
      return downloadBlob(filename, blob)
    } else {
      throw new Error(`Failed to download report [status: ${response.status}]`)
    }
  } catch (error) {
    Logger.error(error)
    NotificationController.showError({
      message: 'Fail to download report',
    })
  }
}
